import { Action, Dispatch } from 'redux'
import { StockUnionType } from 'types/stock'
import { selectDefaultBreadTypesAction } from 'reducks/auth/actions'

const selectDefaultBreadTypes = (defaultBreadTypes: StockUnionType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(selectDefaultBreadTypesAction(defaultBreadTypes))
  }
}

export default selectDefaultBreadTypes
